/* @flow */
import * as React from 'react';
import { Container } from 'flux/utils';
import Badge from 'components/Badge.jsx';
import Image from 'components/Image.jsx';
import Text from 'components/Text.jsx';
import GroupLink from 'groups/components/GroupLink.jsx';
import UnreadStore from 'stores/UnreadStore';
import Organization from 'entities/Organization';

import './styles/NavigationListGroupItem.scss';

type Props = {
  group: *,
  district?: ?Organization,
};

type State = {
  unreadCount: number,
};

class NavigationListGroupItem extends React.Component<Props, State> {
  state = {
    unreadCount: 0,
  };

  static getStores() {
    return [UnreadStore];
  }

  static calculateState(state: State, props: Props) {
    const { group, district } = props;

    if (!district) {
      return {
        unreadCount: UnreadStore.getUnreadCount(group.uuid),
      };
    }

    // for district classes, we should also fetch unreads with
    // the org uuid in order to surface unreads for the chats
    // between the user and the district entity
    return {
      unreadCount:
        UnreadStore.getUnreadCount(group.uuid) + UnreadStore.getUnreadCount(district.get('uuid')),
    };
  }

  hasUnreads() {
    return this.state.unreadCount > 0;
  }

  renderBadge() {
    return (
      this.hasUnreads() && (
        <Badge
          className="NavigationListGroupItem-badge"
          count={this.state.unreadCount}
          color="lava"
          size="large"
          shape="square"
        />
      )
    );
  }

  render() {
    const { group } = this.props;

    if (!group.group_avatar) {
      console.debug(this.props);
      console.error('NavigationListGroupItem - group without avatar');
      return null;
    }

    return (
      <li className="NavigationListGroupItem">
        <GroupLink className="NavigationListGroupItem-link" group={group} color="inherit">
          <div className="NavigationListGroupItem-container">
            <Image
              width={24}
              className="NavigationListGroupItem-avatar"
              src={group.group_avatar.svgUrl}
            />
            <Text
              className="NavigationListGroupItem-name"
              weight={this.hasUnreads() ? 'semibold' : 'normal'}
              truncate>
              {group.displayName}
            </Text>
            {this.renderBadge()}
          </div>
        </GroupLink>
      </li>
    );
  }
}

export { NavigationListGroupItem };
export default Container.create(NavigationListGroupItem, {
  withProps: true,
  pure: false,
});
